import keyBy from 'lodash/keyBy';
import { createReducer } from '../../utilities';

import {
    GET_ALL_ALERT_MPG, GET_ALL_ALERT_MPG_SUCCESS, GET_ALL_ALERT_MPG_ERROR,
    DELETE_ALERT_MPG, DELETE_ALERT_MPG_SUCCESS, DELETE_ALERT_MPG_ERROR,
} from '../../../actions/entities/alertMPG'

const initialAlertMPGList = {
    data: null,
    info: {
        isFetching: false,
        lastAction: null,
        needRefresh: false,
        lastResponse: null,
        updatedAt: null,
        success: null,
        error: null,
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { receivedAt, response } = action;
    return {
        data: response ? keyBy(response, 'id') : null,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            updatedAt: receivedAt,
            success: true,
            error: false
        }
    }
}

function fail(state, action) {
    const { error } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialAlertMPGList, {
    [GET_ALL_ALERT_MPG]: request,
    [GET_ALL_ALERT_MPG_SUCCESS]: success,
    [GET_ALL_ALERT_MPG_ERROR]: fail,

    [DELETE_ALERT_MPG]: request,
    [DELETE_ALERT_MPG_SUCCESS]: success,
    [DELETE_ALERT_MPG_ERROR]: fail,
});



// WEBPACK FOOTER //
// ./src/reducers/app/alertMPG/list.js